// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mTBmad2QwTjtSR {
  position: relative;
  width: 50px;
  height: 32px;
  border: 2px transparent solid;
  border-radius: 3px;
}
.qPOqSoxevArJ2U {
  border: 2px var(--ds-border-selected, #0c66e4) solid;
}
.qPOqSoxevArJ2U::after {
  content: '';
  position: absolute;
  inset: 0;
  border: 2px var(--ds-border-inverse, #ffffff) solid;
  pointer-events: none;
}
.mTBmad2QwTjtSR:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .mTBmad2QwTjtSR:focus {
  outline-color: -webkit-focus-ring-color;
}
.mTBmad2QwTjtSR:focus .mac.firefox {
  outline-color: AccentColor;
}
.C7mXgFUxZSxg5Q {
  position: relative;
  width: 50px;
  height: 32px;
  background-color: var(--tile-background-color, var(--ds-skeleton, #091e420f));
  cursor: pointer;
}
.body-color-blind-mode-enabled .C7mXgFUxZSxg5Q::before,
.body-color-blind-mode-enabled ~ div .C7mXgFUxZSxg5Q::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
}
.C7mXgFUxZSxg5Q:hover {
  background-color: var(--tile-background-color-hovered, var(--ds-skeleton, #091e420f));
}
/**
 * Defines tile color variables on a class for each tile color name.
 * Consumers of tiles outside of their components can import this LESS file,
 * which will load up CSS variables on any element with the corresponding class
 * name (e.g. \`.green\`).
 */
.psoEMZiY0CmP7T {
  --tile-background-color: var(--ds-background-accent-green-subtler, #baf3db);
  --tile-background-color-hovered: var(--ds-background-accent-green-subtler-hovered, #7ee2b8);
  --tile-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.yjhL2D8QKvFnuF {
  --tile-background-color: var(--ds-background-accent-green-subtle, #4bce97);
  --tile-background-color-hovered: var(--ds-background-accent-green-subtle-hovered, #7ee2b8);
  --tile-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.M4tT_T6l_1apmv {
  --tile-background-color: var(--ds-background-accent-green-bolder, #1f845a);
  --tile-background-color-hovered: var(--ds-background-accent-green-bolder-hovered, #216e4e);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.vabyg3N3QlDrjT {
  --tile-background-color: var(--ds-background-accent-yellow-subtler, #f8e6a0);
  --tile-background-color-hovered: var(--ds-background-accent-yellow-subtler-hovered, #f5cd47);
  --tile-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.LZJV5FcjZwWrkP {
  --tile-background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  --tile-background-color-hovered: var(--ds-background-accent-yellow-subtle-hovered, #f5cd47);
  --tile-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.dNt1Rr4DTsuvAh {
  --tile-background-color: var(--ds-background-accent-yellow-bolder, #946f00);
  --tile-background-color-hovered: var(--ds-background-accent-yellow-bolder-hovered, #7f5f01);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.BF80tIFq_zJWET {
  --tile-background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
  --tile-background-color-hovered: var(--ds-background-accent-orange-subtler-hovered, #fec57b);
  --tile-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.LZ825sOqKtSsmp {
  --tile-background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  --tile-background-color-hovered: var(--ds-background-accent-orange-subtle-hovered, #fec57b);
  --tile-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.TCFOHND9uGAlb2 {
  --tile-background-color: var(--ds-background-accent-orange-bolder, #b65c02);
  --tile-background-color-hovered: var(--ds-background-accent-orange-bolder-hovered, #974f0c);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.mgPlq8IOhjoHEi {
  --tile-background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
  --tile-background-color-hovered: var(--ds-background-accent-red-subtler-hovered, #ff9c8f);
  --tile-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.T7PL3GN9y7Oo5N {
  --tile-background-color: var(--ds-background-accent-red-subtle, #f87462);
  --tile-background-color-hovered: var(--ds-background-accent-red-subtle-hovered, #ff9c8f);
  --tile-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.cupvc2BmQzQhjG {
  --tile-background-color: var(--ds-background-accent-red-bolder, #ca3521);
  --tile-background-color-hovered: var(--ds-background-accent-red-bolder-hovered, #ae2a19);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.lomjkrp4ka5UaR {
  --tile-background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  --tile-background-color-hovered: var(--ds-background-accent-purple-subtler-hovered, #b8acf6);
  --tile-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.NSmwirlwfoBipN {
  --tile-background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  --tile-background-color-hovered: var(--ds-background-accent-purple-subtle-hovered, #b8acf6);
  --tile-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.GLjpR3up41DPZE {
  --tile-background-color: var(--ds-background-accent-purple-bolder, #6e5dc6);
  --tile-background-color-hovered: var(--ds-background-accent-purple-bolder-hovered, #5e4db2);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.bqIAvSyd8bIeZ7 {
  --tile-background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  --tile-background-color-hovered: var(--ds-background-accent-blue-subtler-hovered, #85b8ff);
  --tile-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.xAeEUW18BK_6Yg {
  --tile-background-color: var(--ds-background-accent-blue-subtle, #579dff);
  --tile-background-color-hovered: var(--ds-background-accent-blue-subtle-hovered, #85b8ff);
  --tile-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.yZrpNWjLyaXWsZ {
  --tile-background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  --tile-background-color-hovered: var(--ds-background-accent-blue-bolder-hovered, #0055cc);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.s2ddhqzjdEaAal {
  --tile-background-color: var(--ds-background-accent-teal-subtler, #c1f0f5);
  --tile-background-color-hovered: var(--ds-background-accent-teal-subtler-hovered, #8bdbe5);
  --tile-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.MJwW6DofMr4J6f,
.qEnHfO4EX5X3OB {
  --tile-background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  --tile-background-color-hovered: var(--ds-background-accent-teal-subtle-hovered, #8bdbe5);
  --tile-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.d7b9CyXcFCiBX0 {
  --tile-background-color: var(--ds-background-accent-teal-bolder, #1d7f8c);
  --tile-background-color-hovered: var(--ds-background-accent-teal-bolder-hovered, #206b74);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.xFg9y8Rp2GijsZ {
  --tile-background-color: var(--ds-background-accent-lime-subtler, #D3F1A7);
  --tile-background-color-hovered: var(--ds-background-accent-lime-subtler-hovered, #b3df72);
  --tile-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.fOIuo4wTa0QV7V {
  --tile-background-color: var(--ds-background-accent-lime-subtle, #94c748);
  --tile-background-color-hovered: var(--ds-background-accent-lime-subtle-hovered, #b3df72);
  --tile-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.y7UzYg92A0YMIy {
  --tile-background-color: var(--ds-background-accent-lime-bolder, #5b7f24);
  --tile-background-color-hovered: var(--ds-background-accent-lime-bolder-hovered, #4c6b1f);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.qMPZqsNvTUFL_o {
  --tile-background-color: var(--ds-background-accent-magenta-subtler, #fdd0ec);
  --tile-background-color-hovered: var(--ds-background-accent-magenta-subtler-hovered, #f797d2);
  --tile-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.Sxrfh_NhTu3uo3,
.S_HQZ2AewPOQTp {
  --tile-background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  --tile-background-color-hovered: var(--ds-background-accent-magenta-subtle-hovered, #f797d2);
  --tile-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.jFJabHagwZ1Wke {
  --tile-background-color: var(--ds-background-accent-magenta-bolder, #ae4787);
  --tile-background-color-hovered: var(--ds-background-accent-magenta-bolder-hovered, #943d73);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.WtFmNQTowUrV8H {
  --tile-background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  --tile-background-color-hovered: var(--ds-background-accent-gray-subtler-hovered, #b3b9c4);
  --tile-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.JROZL3p3PDktQ9,
.rkisJf3bwk9fe7 {
  --tile-background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  --tile-background-color-hovered: var(--ds-background-accent-gray-subtle-hovered, #b3b9c4);
  --tile-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.kb5_0SadX7drrp {
  --tile-background-color: var(--ds-background-accent-gray-bolder, #626f86);
  --tile-background-color-hovered: var(--ds-background-accent-gray-bolder-hovered, #44546f);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tileContainer": `mTBmad2QwTjtSR`,
	"tileContainer--selected": `qPOqSoxevArJ2U`,
	"tile": `C7mXgFUxZSxg5Q`,
	"green_light": `psoEMZiY0CmP7T`,
	"green": `yjhL2D8QKvFnuF`,
	"green_dark": `M4tT_T6l_1apmv`,
	"yellow_light": `vabyg3N3QlDrjT`,
	"yellow": `LZJV5FcjZwWrkP`,
	"yellow_dark": `dNt1Rr4DTsuvAh`,
	"orange_light": `BF80tIFq_zJWET`,
	"orange": `LZ825sOqKtSsmp`,
	"orange_dark": `TCFOHND9uGAlb2`,
	"red_light": `mgPlq8IOhjoHEi`,
	"red": `T7PL3GN9y7Oo5N`,
	"red_dark": `cupvc2BmQzQhjG`,
	"purple_light": `lomjkrp4ka5UaR`,
	"purple": `NSmwirlwfoBipN`,
	"purple_dark": `GLjpR3up41DPZE`,
	"blue_light": `bqIAvSyd8bIeZ7`,
	"blue": `xAeEUW18BK_6Yg`,
	"blue_dark": `yZrpNWjLyaXWsZ`,
	"sky_light": `s2ddhqzjdEaAal`,
	"sky": `MJwW6DofMr4J6f`,
	"teal": `qEnHfO4EX5X3OB`,
	"sky_dark": `d7b9CyXcFCiBX0`,
	"lime_light": `xFg9y8Rp2GijsZ`,
	"lime": `fOIuo4wTa0QV7V`,
	"lime_dark": `y7UzYg92A0YMIy`,
	"pink_light": `qMPZqsNvTUFL_o`,
	"pink": `Sxrfh_NhTu3uo3`,
	"magenta": `S_HQZ2AewPOQTp`,
	"pink_dark": `jFJabHagwZ1Wke`,
	"black_light": `WtFmNQTowUrV8H`,
	"black": `JROZL3p3PDktQ9`,
	"gray": `rkisJf3bwk9fe7`,
	"black_dark": `kb5_0SadX7drrp`
};
export default ___CSS_LOADER_EXPORT___;
